angular
    .module('MyApp')
    .service('OportunidadesService', ['$resource', '$q', 'SessionData', 'Configs', 
         function($resource, $q, SessionData, Configs) {
            

        this.buscarVagasEstagio = function(codCurso, uf, municipio, empresa){
            let deferr = $q.defer();
                $resource(Configs.getApiServer() + '/v2/alunos/vagas-estagio?curso=:codCurso&uf=:uf&municipio=:municipio&empresa=:empresa',
                    {}, { 'query': { method: 'GET', isArray: false } }).query({
                        codCurso, uf, municipio, empresa
                    }, function (response) {
                        deferr.resolve(response);
    
                    }, function(){
                        deferr.reject();
                    });
            return deferr.promise;
        }

        this.buscarEmpresas = function(){
            let deferr = $q.defer();
                $resource(Configs.getApiServer() + '/comum/empresas',
                    {}, { 'query': { method: 'GET', isArray: true } }).query({
                    }, function (response) {
                        deferr.resolve(response);
    
                    }, function(){
                        deferr.reject();
                    });
            return deferr.promise;
            }


    }]);